module.exports = __webpack_public_path__ + "img/timeline_mainevent-15.66e987ef.jpg";